import styled from '@emotion/styled';

export const SWrapper = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;
export const SCard = styled.div`
  width: 364px;
  background: white;
  padding: 20px;
  margin: 20px;
`;
